import React, { useContext, useEffect, useState, useRef } from 'react';
import { Input, RadioGroup } from '@progress/kendo-react-inputs';
import DeleteFormItem from '../../DeleteFormItem';
import { LocalizationContext } from '../../../contexts';
import Uploader, { uploaderTypes } from '../../Uploader';
import PublishSwitch from '../publishSwitch';
import './index.scss';
import '../forms.scss';

export default function HeroBanner({ data, type, updateFullCompData, ...rest }) {
  const emptyItem = useRef({ title: "", image: "", image_mobile: "", animate_json: "", animate_json_mobile: "", link: "", link_target: "_top", isPublish: false });
  const [compData, setCompData] = useState({});
  //const [validateMode, setValidateMode] = useState(false);
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;

  useEffect(() => {
    const defaultData = { ...emptyItem.current };
    setCompData({ ...defaultData, ...data });
  }, [data]);

  const handleDeleteClick = () => {
    const newCompData = { ...compData, ...emptyItem.current };
    setCompData(newCompData);
    updateFullCompData(newCompData, type);
  };

  const updateItem = (newData) => {
    let newCompData = { ...compData, ...newData };
    setCompData(newCompData);
    updateFullCompData(newCompData, type);
  }

  const isEmptyItem = () => {
    return JSON.stringify(compData) === JSON.stringify(emptyItem.current)
  }

  const showRequired = (requiredField) => {
    let noRequiredField;
    if (requiredField.length > 1) {
      noRequiredField = (!compData[requiredField[0]] && !compData[requiredField[1]]) || (compData[requiredField[0]] && compData[requiredField[1]])
    } else {
      noRequiredField = !compData[requiredField[0]];
    }
    return !isEmptyItem() && noRequiredField;
  }

  const canPublish = () => {
    if (!compData.title ||
      !(compData.image_mobile || compData.animate_json_mobile) ||
      !(compData.image || compData.animate_json)) {
      return false;
    }
    return true;
  }

  return (
    <div className="form-content">
      <div className="form-item">
        <div className="form-item__title">
          {compData?.title} {!isEmptyItem() && <DeleteFormItem handleDeleteClick={handleDeleteClick} />}
        </div>
        <div className="form-field">
          <label className="form-field__label">{labels.pagesManagement.forms.add_pc_banner}</label>
          <Uploader type={uploaderTypes.image} imageUrl={compData.image} prefix={'heroBanner'} onChange={(file) => { updateItem({ image: file }) }} />
        </div>
        <div className="form-field separator"><label className="form-field__label">{labels.pagesManagement.forms.or}</label></div>
        <div className="form-field">
          <label className="form-field__label">{labels.pagesManagement.forms.add_pc_animation}</label>
          <Uploader type={uploaderTypes.animation} animationUrl={compData.animate_json} prefix={'heroBanner'} onChange={(file) => { updateItem({ animate_json: file }) }} />
          {showRequired(['image', 'animate_json']) && <div className="form-field__required">{labels.pagesManagement.forms.required_image_or_animation}</div>}
        </div>
        <div className="form-field">
          <label className="form-field__label">{labels.pagesManagement.forms.add_mobile_banner}</label>
          <Uploader type={uploaderTypes.image} imageUrl={compData.image_mobile} prefix={'heroBanner'} onChange={(file) => { updateItem({ image_mobile: file }) }} />
        </div>
        <div className="form-field separator"><label className="form-field__label">{labels.pagesManagement.forms.or}</label></div>
        <div className="form-field">
          <label className="form-field__label">{labels.pagesManagement.forms.add_mobile_animation}</label>
          <Uploader type={uploaderTypes.animation} animationUrl={compData.animate_json_mobile} prefix={'heroBanner'} onChange={(file) => { updateItem({ animate_json_mobile: file }) }} />
          {showRequired(['image_mobile', 'animate_json_mobile']) && <div className="form-field__required">{labels.pagesManagement.forms.required_image_or_animation}</div>}
        </div>
        <div className="form-field">
          <label className="form-field__label">{labels.pagesManagement.forms.add_link}</label>
          <Input name={'link'} value={compData.link} onChange={({ value }) => updateItem({ link: value })}></Input>
          <RadioGroup data={[
            { label: labels.pagesManagement.forms.open_top, value: '_top' },
            { label: `${labels.pagesManagement.forms.open_blank} (${labels.pagesManagement.forms.for_external_links})`, value: '_blank' }
          ]}
            layout='horizontal'
            value={compData.link_target}
            onChange={({ value }) => {
              updateItem({ link_target: value });
            }}
          />
        </div>
        <div className="form-field">
          <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_accessibility_title} ({labels.pagesManagement.forms.banner_short_description})</label>
          <Input name={'title'} value={compData.title} onChange={({ value }) => updateItem({ title: value })}></Input>
          {showRequired(['title']) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
        </div>
        <PublishSwitch isPublish={compData?.isPublish} canPublish={canPublish()}
          updateItem={(event) => updateItem({ isPublish: event.target.value })} />
      </div>
    </div>
  );
};